import { render, staticRenderFns } from "./tab-jkt.vue?vue&type=template&id=354de94a&scoped=true"
import script from "./tab-jkt.vue?vue&type=script&lang=js"
export * from "./tab-jkt.vue?vue&type=script&lang=js"
import style0 from "./tab-jkt.vue?vue&type=style&index=0&id=354de94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354de94a",
  null
  
)

export default component.exports